// @flow
import React, { Component, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { copyToClipboard } from '../../../../utils/clipboard';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import Modal from '../../../../elements/Modal/Modal';
import Loading from '../../../../elements/Loading/Loading';

import style from './PunchCardModal.scss';
import icons from '../../../../assets/styles/icons.scss';
import gift from '../../../../assets/img/punch-card/REGALITO.png';
import yogiError from '../../../../assets/img/yogi-400.png';

import type { HTTPError } from '../../../../error';

type Props = {
  isOpen?: boolean;
  coupon?: string;
  handleClose: () => void;
  isClaimingPoints?: boolean;
  claimPointsError?: HTTPError;
};

export default class PunchCardModal extends Component<Props> {

  render() {
    const { coupon, isOpen, handleClose, isClaimingPoints, claimPointsError } = this.props;
    return (
      <Modal open={isOpen}
             big
             handleClose={() => !isClaimingPoints && handleClose()}>
        {isClaimingPoints ?
          <Loading type="sk-three-bounce"
                   className={style.modalLoading}
                   number={3}/> :
          <section className={style.modalWrap}>{
            !!claimPointsError ?
              <Fragment>
                <img src={yogiError}
                     className={style.modalImage}
                     alt="gift"/>
                <FormattedMessage id="httpErrors.post.400">{
                  txt => <p className={style.modalTitle}>{txt}</p>
                }</FormattedMessage>
              </Fragment> :
              <Fragment>
                <img src={gift}
                     className={style.modalImage}
                     alt="gift"/>
                <FormattedMessage id="punchCard.modal.title">{
                  txt => <p className={style.modalTitle}>{txt}</p>
                }</FormattedMessage>
                <FormattedMessage id="punchCard.modal.label">{
                  txt => <p className={style.modalSubtitle}>{txt}</p>
                }</FormattedMessage>
                <article className={style.couponWrap}>
                  <i className={classNames(icons.symbolGift)}/>
                  <FormattedMessage id="punchCard.modal.coupon">{
                    txt => <span>{txt}: <strong>{coupon}</strong></span>
                  }</FormattedMessage>
                  <FormattedMessage id="punchCard.modal.copy">{
                    txt => <button onClick={() => copyToClipboard(coupon || '')}>{txt}</button>
                  }</FormattedMessage>
                </article>
              </Fragment>}
          </section>}
      </Modal>
    );
  }
}

PunchCardModal.propTypes = {
  isOpen: PropTypes.bool,
  coupon: PropTypes.string,
  handleClose: PropTypes.func.isRequired,
  isClaimingPoints: PropTypes.bool,
  claimPointsError: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/modules/punch-card/components/PunchCardModal/PunchCardModal.jsx